
export default {
  name: 'AppMain',
  computed: {}
};